import { SET_BRANCH_DELIVERY_CHARGE } from "./actionTypes";
// import instance from "./instance";

export const setBranchDeliveryCharge = bdc_obj => {
  return {
    type: SET_BRANCH_DELIVERY_CHARGE,
    payload: bdc_obj
  };
};
